import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MediaQuery from 'react-responsive';
import FabButton from '../FabButton';
import { browser } from '../BrowserSupport/';
import ManualEntryIcon from '@material-ui/icons/Keyboard';
import QRGunIcon from '../Icons/QRGun';
import CloseIcon from '@material-ui/icons/Close';
import CameraIcon from '@material-ui/icons/PhotoCamera';
import classNames from 'classnames';
import styles from './styles';

class AuthChooserButton extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            open: false,
            drawerOpen: false,
        };
    }

    handleClick = () => {
        const isOpen = this.state.open;
        const newState = !isOpen;

        this.setState({
            open: newState
        });
    };

    handleDrawerOpen = () => {
        this.setState({ drawerOpen: true });
    };

    handleDrawerClose = () => {
        this.setState({ drawerOpen: false });
    };

    handleClose = (_, reason) => {
        if (reason !== 'mouseLeave')
            this.setState({ open: false, lastClickTime: null });
    };

    handleOpen = () => {
        this.setState({ open: true });
    };

    delegateAction = (delegate, currentContext) => {
        this.handleClose();
        delegate(currentContext);
    };

    speedDialSelector = () => {

        const {
            classes,
            qrCodeClicked,
            qrScannerClicked,
            forgottenCardClicked,
            currentContext,
            text,
            disabled,
            icon: Icon
        } = this.props;

        const { open } = this.state;
        const isDisabled = Boolean(disabled);

        return (
            <ClickAwayListener onClickAway={this.handleClose}>
                <SpeedDial
                    ariaLabel={text}
                    disabled={isDisabled}
                    className={classes.speedDial}
                    icon={open ? <CloseIcon /> : <Icon />}
                    onClick={this.handleClick}
                    onClose={this.handleClose}
                    open={open}
                    direction="up"
                    FabProps={{
                        color: 'secondary',
                        variant: 'extended',
                        style: {
                            minWidth: 160
                        },
                        ref: (button) => {
                            if (!button || button.querySelector('.SpeedDialFab-text')) return;
                            const span = document.createElement("span");
                            span.className = "SpeedDialFab-text";
                            span.innerHTML = text;
                            span.style.marginLeft = '8px';
                            button.appendChild(span);
                        }
                    }}
                >
                    <SpeedDialAction
                        icon={<ManualEntryIcon />}
                        tooltipTitle="Forgotten Card"
                        tooltipOpen
                        FabProps={{
                            color: 'secondary'
                        }}
                        onClick={() => this.delegateAction(forgottenCardClicked, currentContext)} />

                    {!browser.mobile &&
                        <SpeedDialAction
                            icon={<QRGunIcon />}
                            tooltipTitle="QR Code (Scanner)"
                            tooltipOpen
                            FabProps={{
                                color: 'secondary'
                            }}
                            onClick={() => this.delegateAction(qrScannerClicked, currentContext)} />
                    }

                    <SpeedDialAction
                        icon={<CameraIcon />}
                        tooltipTitle="QR Code (Camera)"
                        tooltipOpen
                        FabProps={{
                            color: 'secondary'
                        }}
                        onClick={() => this.delegateAction(qrCodeClicked, currentContext)} />
                </SpeedDial>
            </ClickAwayListener>
        );
    };

    drawerSelector = () => {
        const {
            qrCodeClicked,
            qrScannerClicked,
            forgottenCardClicked,
            currentContext,
            text,
            icon: Icon,
            disabled,
            classes
        } = this.props;

        const { drawerOpen } = this.state;
        const isDisabled = Boolean(disabled);

        return (
            <div>
                <FabButton onClick={this.handleDrawerOpen} disabled={isDisabled}>
                    <Icon />
                    <span style={{ marginLeft: 8 }}>
                        {text}
                    </span>
                </FabButton>
                <Drawer anchor="bottom" open={drawerOpen} onClose={this.handleDrawerClose}>
                    <div tabIndex={0} role="button">
                        <List>
                            <ListItem button onClick={() => this.delegateAction(qrCodeClicked, currentContext)}>
                                <ListItemIcon>
                                    <CameraIcon className={classes.listItem} />
                                </ListItemIcon>
                                <ListItemText>
                                    QR Code (Camera)
                                </ListItemText>
                            </ListItem>
                            {!browser.mobile &&
                                <ListItem button onClick={() => this.delegateAction(qrScannerClicked, currentContext)}>
                                    <ListItemIcon>
                                        <QRGunIcon className={classes.listItem} />
                                    </ListItemIcon>
                                    <ListItemText>
                                        QR Code (Scanner)
                                    </ListItemText>
                                </ListItem>
                            }
                            <ListItem button onClick={() => this.delegateAction(forgottenCardClicked, currentContext)}>
                                <ListItemIcon>
                                    <ManualEntryIcon className={classes.listItem} />
                                </ListItemIcon>
                                <ListItemText>
                                    Forgotten Card
                                </ListItemText>
                            </ListItem>
                            <Divider />
                            <ListItem button onClick={this.handleDrawerClose}>
                                <ListItemIcon>
                                    <CloseIcon className={classes.listItem} />
                                </ListItemIcon>
                                <ListItemText>
                                    Close
                                </ListItemText>
                            </ListItem>
                        </List>
                    </div>
                </Drawer>
            </div>);
    };

    render() {
        const {
            classes,
            preventPositioning
        } = this.props;

        const shouldPreventPosition = Boolean(preventPositioning);

        return (
            <div className={classNames(shouldPreventPosition ? '' : classes.wrapper, this.props.className)}>
                <MediaQuery maxWidth={767}>
                    {(isSmall) => isSmall ? this.drawerSelector() : this.speedDialSelector()}
                </MediaQuery>
            </div >
        );
    }
}

AuthChooserButton.propTypes = {
    disabled: PropTypes.bool,
    text: PropTypes.string,
    forgottenCardClicked: PropTypes.func.isRequired,
    qrCodeClicked: PropTypes.func.isRequired,
    qrScannerClicked: PropTypes.func.isRequired,
    currentContext: PropTypes.string,
    icon: PropTypes.func,
    preventPositioning: PropTypes.bool
};

export default withStyles(styles)(AuthChooserButton);